<div id="faq-container" class="web-center">
    <div class="w-75 ">
        <div class="row">
            <div class="faq-title">Frequently Asked Questions</div>
            <div class="mt-5 mb-5">
                <div class="quality-boxes-container">
                    <div *ngFor="let faqSection of getFaqEntries(); trackBy: trackByIndex" class="quality-box" (click)="selectSection(faqSection[0])" [class.selected]="selectedSection === faqSection[0]">
                        <img [src]="faqSection[1].image" alt="">
                        <h3>{{ faqSection[0].replace(':', '') }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div>
        <div id="faq-accordions" class="row" style="display: flex; justify-content: center; margin-bottom: 20px;">
            <div class="col-md-8">

                <ng-container *ngIf="getSelectedSectionName() != 'Nutrition Support:'">
                    <p-accordion class="web-left">
                        <span class="header">{{ getSelectedSectionName() }}</span>
                        <p-accordionTab *ngFor="let faq of getSelectedFaqSection(); trackBy: trackByIndex" [header]="faq.header" class="header">
                            <p class="body" [innerHtml]="faq.body"></p>
                        </p-accordionTab>
                    </p-accordion>
                </ng-container>

                
            </div>

            <ng-container *ngIf="getSelectedSectionName() == 'Nutrition Support:'">
                    <div>
                        <span class="header">{{ getSelectedSectionName() }}</span>
                    </div>
                    <div>
                        We offer dedicated nutrition support to help you meet your health and performance goals. 
                        <br>
                        Our experienced nutrition support team, along with elite coaches, can provide personalised guidance and recommendations tailored to your individual needs.
                        <br><br>
                        If you’d like support with your nutrition, please get in touch with us by sending an email at <a href="mailto:support@nutrigenic.co.uk">support@nutrigenic.co.uk</a>, and our team will be happy to assist and connect you with the right experts.
                    </div>
                    <app-health-help></app-health-help>
                </ng-container>
        </div>
    </div>

    <div class="promo-bottom-box">
        <svg xmlns="http://www.w3.org/2000/svg" width="219" height="93" viewBox="0 0 219 93" fill="none">
            <path d="M218.5 1L134.589 28.7137C118.296 34.095 100.704 34.095 84.411 28.7137L0.499997 1.00002" stroke="#EF870A"/>
            <path d="M218.5 29L134.589 56.7137C118.296 62.095 100.704 62.095 84.411 56.7137L0.499997 29" stroke="#EF870A"/>
            <path d="M218.5 57L134.589 84.7137C118.296 90.095 100.704 90.095 84.411 84.7137L0.499997 57" stroke="#EF870A"/>
        </svg>
        <div style="width: 100%; height: 100%; border-radius: 200px; backdrop-filter: blur(2px); flex-direction: column; justify-content: center; align-items: center; gap: 20px; display: inline-flex">
            <div class="hungry-for-more">Next Step?</div>
            <div class="punchline">Taste the Difference</div>
        </div>
        
    </div>
    <div style="margin-top: 48px; margin-bottom:75px">
        <app-offer-banner [sticky]="false" link="/order-flow"/>
    </div>
</div>